/* Native details remains fully usable without this enhancement. */
if (!window.slNavigationReady) {
 window.slNavigationReady = true;
 document.addEventListener('keydown', function(event) {
  if (event.key !== 'Escape') return;
  const item = event.target.closest('.sl-header details[open]');
  if (item) { item.open = false; item.querySelector('summary').focus(); }
 });
 document.addEventListener('click', function(event) {
  document.querySelectorAll('.sl-header details[open]').forEach(function(item) {
   if (!item.contains(event.target)) item.open = false;
  });
 });
}
